// 설정 상호 한 벌 — 저장 액션·회사 탭(처음 로드·입력 중·저장 뒤 칸 값)·설정 읽기와 문서(계약서·현장 공지·접수 포스터·변경 계약)의 상호(org.name 대체값)가 같이 쓴다.

import { cleanName, controlCharsToSpace, hasControlChars, stripInvisible } from "../../lib/control-chars";
import { controlCharsMessage, isRawNameTooLong, parseOptionalNameText, type NameParsed } from "../../lib/name-text";
import { COMPANY_NAME_RULE } from "./types";

// 시공사 만들기와 같은 상호 검사(코드포인트 · 정리값 저장 · 주소 꼴 허용) — 라벨만 칸 이름 「상호」.
const SETTINGS_COMPANY_NAME_RULE = { ...COMPANY_NAME_RULE, label: "상호" };

export const COMPANY_NAME_FIX_HINT = "상호 칸을 지우고 다시 입력해 주세요";

// 비우거나 보이지 않는 글자뿐이면 빈 값 · 보이지 않는 문자가 있으면 길이 오류보다 먼저(보이지 않는 글자도 글자 수에 들어간다) 고치는 법을 붙여 알린다.
export const parseSettingsCompanyName = (raw: unknown): NameParsed => {
  const parsed = parseOptionalNameText(raw, SETTINGS_COMPANY_NAME_RULE);
  if (parsed.ok || typeof raw !== "string" || isRawNameTooLong(raw, COMPANY_NAME_RULE.max) || !hasControlChars(cleanName(raw))) return parsed;
  return { ok: false, error: `${controlCharsMessage(SETTINGS_COMPANY_NAME_RULE)} — ${COMPANY_NAME_FIX_HINT}` };
};

// 상호를 비웠을 때 쓰는 org.name — 검사를 지나면 정리값 · 제어문자에 걸리면 보이지 않는 글자를 지우고 공백으로 접어(mailSafeName 과 같은 순서) 다시 검사 · 그래도 걸리면 빈 값(회사 탭이 갇히지 않는다).
export const companyNameFallback = (orgName: string | null | undefined): string => {
  const raw = orgName ?? "";
  const parsed = parseSettingsCompanyName(raw);
  if (parsed.ok) return parsed.value;
  const retry = parseSettingsCompanyName(controlCharsToSpace(stripInvisible(raw)));
  return retry.ok ? retry.value : "";
};

// 화면·문서의 상호 — 설정 상호가 먼저 · 비었으면 org.name 대체값.
export const companyNameOf = (setting: string | null | undefined, orgName: string | null | undefined): string =>
  (setting ?? "").trim() || companyNameFallback(orgName);

// 조직 표시명(고객·문서에 찍는 상호) — 설정 상호 → org.name 대체값 → 그마저 비면 제어문자만 접은 org.name(문서에 빈 상호를 찍지 않는다).
export const orgDisplayNameOf = (setting: string | null | undefined, orgName: string | null | undefined): string =>
  companyNameOf(setting, orgName) || cleanName(controlCharsToSpace(stripInvisible(orgName ?? "")));
